var _g, _g2, _g3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallsToAction = function SvgCallsToAction(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 248,
    height: 124,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#calls_to_action_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 69.2,
    width: 120,
    height: 28.8,
    rx: 4.8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calls_to_action_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.07 83.82a2.71 2.71 0 0 0-3.493-4.123l-.03.02a.599.599 0 1 0 .698.975l.03-.02a1.51 1.51 0 0 1 1.946 2.299l-2.104 2.107a1.51 1.51 0 0 1-2.299-1.946l.021-.03a.6.6 0 0 0-.975-.698l-.02.03a2.71 2.71 0 0 0 4.121 3.491l2.105-2.105Zm-9.742-.439a2.71 2.71 0 0 0 3.493 4.123l.03-.02a.599.599 0 1 0-.698-.975l-.03.02a1.513 1.513 0 0 1-1.946-2.3l2.104-2.106a1.51 1.51 0 0 1 2.299 1.948l-.021.03a.6.6 0 0 0 .975.698l.02-.03a2.71 2.71 0 0 0-4.121-3.493l-2.105 2.105Z",
    fill: "#751CBF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 77.601,
    width: 72,
    height: 4.8,
    rx: 2.4,
    fill: "#F0EDF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 84.801,
    width: 36,
    height: 4.8,
    rx: 2.4,
    fill: "#F9F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calls_to_action_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M169.729 83.606a.898.898 0 0 1 1.536-.636.9.9 0 1 1-1.536.636Zm2.571 0a.9.9 0 1 1 1.799 0 .9.9 0 0 1-1.799 0Zm3.471-.9a.901.901 0 1 1 0 1.802.901.901 0 0 1 0-1.802Z",
    fill: "#D6D2D9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#calls_to_action_svg__d)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 47.6,
    width: 160,
    height: 38.4,
    rx: 6.4,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calls_to_action_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M68.094 67.092a3.614 3.614 0 0 0-4.657-5.497l-.04.027a.798.798 0 1 0 .93 1.3l.04-.027a2.014 2.014 0 0 1 2.595 3.065l-2.805 2.81a2.014 2.014 0 0 1-3.065-2.595l.027-.04a.8.8 0 0 0-1.3-.93l-.027.04a3.614 3.614 0 0 0 5.495 4.655l2.807-2.808Zm-12.99-.585a3.614 3.614 0 0 0 4.658 5.498l.04-.028a.798.798 0 1 0-.93-1.3l-.04.028c-.803.572-1.9.482-2.595-.215a2.017 2.017 0 0 1 0-2.853l2.805-2.807a2.014 2.014 0 0 1 3.065 2.597l-.028.04a.8.8 0 0 0 1.3.93l.028-.04a3.614 3.614 0 0 0-5.495-4.657l-2.808 2.807Z",
    fill: "#751CBF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 58.8,
    width: 96,
    height: 6.4,
    rx: 3.2,
    fill: "#F0EDF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 68.399,
    width: 48,
    height: 6.4,
    rx: 3.2,
    fill: "#F9F7FA"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calls_to_action_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.971 66.806a1.2 1.2 0 1 1 2.4 0 1.2 1.2 0 0 1-2.4 0Zm3.428 0a1.2 1.2 0 1 1 2.402.002 1.2 1.2 0 0 1-2.402-.002Zm4.629-1.2a1.2 1.2 0 1 1 0 2.4 1.2 1.2 0 0 1 0-2.4Z",
    fill: "#D6D2D9"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#calls_to_action_svg__g)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 200,
    height: 48,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calls_to_action_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.118 46.366a4.517 4.517 0 0 0 0-6.391 4.518 4.518 0 0 0-5.822-.481l-.05.034a.998.998 0 0 0-.23 1.394 1 1 0 0 0 1.393.231l.05-.034a2.518 2.518 0 0 1 3.244 3.831l-3.507 3.513a2.518 2.518 0 0 1-3.83-3.244l.034-.05a1 1 0 0 0-1.625-1.163l-.035.05a4.517 4.517 0 0 0 6.869 5.819l3.51-3.51Zm-16.237-.732a4.517 4.517 0 0 0 0 6.391 4.518 4.518 0 0 0 5.822.481l.05-.034a.997.997 0 0 0 .231-1.394 1 1 0 0 0-1.394-.231l-.05.034a2.515 2.515 0 0 1-3.243-.269 2.522 2.522 0 0 1 0-3.565l3.506-3.51a2.52 2.52 0 0 1 3.831 3.247l-.034.05a1 1 0 0 0 1.625 1.163l.034-.05a4.517 4.517 0 0 0-6.869-5.822l-3.51 3.51Z",
    fill: "#751CBF"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 36,
    width: 120,
    height: 8,
    rx: 4,
    fill: "#F0EDF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 48,
    width: 60,
    height: 8,
    rx: 4,
    fill: "#F9F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.214 46.008a1.5 1.5 0 1 1 3.002 0 1.5 1.5 0 0 1-3.002 0Zm4.286 0a1.5 1.5 0 1 1 3.002 0 1.5 1.5 0 0 1-3.002 0Zm5.785-1.5a1.5 1.5 0 1 1 0 2.999 1.5 1.5 0 0 1 0-3Z",
    fill: "#D6D2D9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calls_to_action_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(71.2 78.8)",
    d: "M0 0h12v9.6H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "calls_to_action_svg__c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(169.6 79.491)",
    d: "M0 0h7.2v8.229H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "calls_to_action_svg__e"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(53.6 60.4)",
    d: "M0 0h16v12.8H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "calls_to_action_svg__f"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(184.8 61.32)",
    d: "M0 0h9.6v10.971H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "calls_to_action_svg__h"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(36 38)",
    d: "M0 0h20v16H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "calls_to_action_svg__a",
    x: 40,
    y: 47.2,
    width: 168,
    height: 76.8,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4063_5126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4063_5126",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "calls_to_action_svg__d",
    x: 20,
    y: 25.6,
    width: 208,
    height: 86.4,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4063_5126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4063_5126",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "calls_to_action_svg__g",
    x: 0,
    y: 0,
    width: 248,
    height: 96,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4063_5126"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_4063_5126",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallsToAction);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "8796c63f0e95ab655f3bfd63ec28e3b3.svg";